import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
const updateSupportRequestMutation = gql`mutation update_support_requests(
  $id: uuid!,
	$support_request: support_requests_set_input
){
  update_support_requests_by_pk(
    pk_columns:{
      id: $id
    },
    _set: $support_request
  ){
    id
  }
}`;

const insertSupportConversationMutation = gql`
  mutation insert_support_requests_conversations(
    $conversation: support_requests_conversations_insert_input!
  ) {
    insert_support_requests_conversations_one(object: $conversation) {
      id
    }
  }
`;

const getSupportRequestsConversationQuery = gql`
  subscription  GetSupportRequestsConversations($support_request_id: uuid!) {
    support_requests_conversations(
      where: { support_request_id: { _eq: $support_request_id } }
      order_by: { created_at: asc }
    ) {
      id
      created_at
      sender_id
      sender_type
      message
      attachments
      support_request_id
      support_request_number
    }
  }
`;


const UPDATE_SUPPORT_STATUS = gql`
  mutation UpdateSupportStatus($id: uuid!, $status: String!) {
    update_support_requests_by_pk(
      pk_columns: { id: $id }
      _set: { status: $status }
    ) {
      id
      status
    }
  }
`;



@Injectable({
  providedIn: 'root'
})
export class UpdateSupportRequestsService {

  constructor(
    private apollo: Apollo
  ) { }

  updateSupportRequest(id: string, support_request: any){
    return this.apollo.use('external').mutate({
      mutation: updateSupportRequestMutation,
      variables: {
        id,
        support_request
      }
    }).toPromise();
  }

    addSupportConversation(conversation: any) {
    return this.apollo.use('external').mutate({
      mutation: insertSupportConversationMutation,
      variables: {
        conversation
      }
    }).toPromise();
  }

getSupportRequestsConversationData(support_request_id: string) {
  return this.apollo.use('external').subscribe({
    query: getSupportRequestsConversationQuery,
    variables: { support_request_id }
  });
}

  updateStatus(id: string, status: string) {
    return this.apollo.mutate({
      mutation: UPDATE_SUPPORT_STATUS,
      variables: { id, status },
    });


}
}


